/********************  START WEB API SLUG ************* */

// Prefixed WEB URL

//Athencation
const ADMIN = "/admin/";
const API = "/api";
export const LOGIN = ADMIN + "auth/login";

// Dashboard
export const GET_DASHBOARD_DATA = API + ADMIN + "dashboard/dashboard-data";

// change password
export const CHANGE_PASSWORD = API + ADMIN + "change-password";

// crop crud
export const ADD_CROP = API + ADMIN + "master/add-crop";
export const GET_CROP_LIST = API + ADMIN + "master/list-crop";
export const UPDATE_CROP = API + ADMIN + "master/update-crop";

// service master
export const GET_SERVICE_LIST = API + ADMIN + "master/list-service";
export const ADD_SERVICE = API + ADMIN + "master/add-service";
export const EDIT_SERVICE = API + ADMIN + "master/update-service";

// spray for proble
export const ADD_PROBLEM = API + ADMIN + "master/add-spray-for-problem";
export const GET_PROBLEM_LIST = API + ADMIN + "master/list-spray-for-problem";
export const UPDATE_PROBLEM = API + ADMIN + "master/update-spray-for-problem";
export const CHANGE_PROBLEM_STATUS =
  API + ADMIN + "master/change-spray-for-problem-status";

// announcement
export const GET_ANNOUCE_LIST =
  API + ADMIN + "user/list-farmer-for-announcement";
export const SEND_ANNOUNCEMENT = API + ADMIN + "user/send-announcement";

// operator
export const GET_OPERATOR_LIST = API + ADMIN + "user/list-operator";
export const ADD_OPERATOR = API + ADMIN + "user/add-operator";
export const EDIT_OPERATOR = API + ADMIN + "user/update-operator";
export const CHANGE_OPERATOR_STATUS =
  API + ADMIN + "user/change-operator-status";
export const GET_OPERATORBYID = API + ADMIN + "user/get-operator-by-id";
export const SUBMIT_MONEY_RECIEVE = API + ADMIN + "user/add-received-payment";
export const GET_MONEY_RECIEVE_LIST =
  API + ADMIN + "user/list-received-payment";

// equipment
export const ADD_EQUIPMENT = API + ADMIN + "master/add-equipment";
export const GET_EQUIPMENT_LIST = API + ADMIN + "master/list-equipment";
export const UPDATE_EQUIPMENT = API + ADMIN + "master/update-equipment";
export const CHANGE_EQUIPMENT_STATUS =
  API + ADMIN + "master/change-equipment-status";

// bookings menu
export const GET_BOOKING_LIST = API + ADMIN + "booking/list-booking-data";
export const ASSIGN_OPERATOR = API + ADMIN + "booking/assign-operator";
export const GET_BOOKING_DETAIL = API + ADMIN + "booking/booking-data-by-id";
export const SET_BOOKING_STATUS =
  API + ADMIN + "booking/cancle-reschedule-booking";
export const GET_ASSIGN_OPERATORS =
  API + ADMIN + "booking/assign-operator-list";
export const CHANGE_CASH_STATUS =
  API + ADMIN + "booking/change-cash-payment-status";
export const ADD_BOOKING = API + ADMIN + "booking/cash-payment";

// service Item master
export const GET_SERVICEITEM_LIST = API + ADMIN + "master/list-service-item";
export const ADD_SERVICEITEM = API + ADMIN + "master/add-service-item";
export const EDIT_SERVICEITEM = API + ADMIN + "master/update-service-item";
export const GET_SERVICE_BY_ID = API + ADMIN + "master/get-service-by-id";

// Booking Slots
export const GET_BOOKING_SLOTS_LIST = API + ADMIN + "master/list-time-slots";
export const BOOKING_SLOTS = API + ADMIN + "master/add-time-slot";
export const EDIT_BOOKING_SLOTS = API + ADMIN + "master/update-time-slot";

// Farmer List
export const GET_FARMER_PROFILE = API + ADMIN + "user/get-farmer-by-id";
export const GET_FARMER_LIST = API + ADMIN + "user/list-farmer";
export const GET_FARM_LIST = API + ADMIN + "user/list-farm";
export const ADD_WALLET_POINT = API + ADMIN + "user/add-wallet-points";
export const CHANGE_SOIL_SENSE_STATUS = API + ADMIN + "user/change-soil-sense-status";
export const ADD_FARMER = API + ADMIN + "user/add-farmer";
export const DELETE_FARMER = API + ADMIN + "user/delete-farmer";

// setting
export const GET_GLOBAL_LIST = API + ADMIN + "global/get-global-data";
export const UPDATE_GLOBAL_STATUS = API + ADMIN + "global/update-global-data";


// add soil test parameter
export const ADD_SOIL_TEST_PARAMETER = API + ADMIN + "master/add-soil-parameter";
export const GET_LIST_SOIL_PARAMETER = API + ADMIN + "master/list-soil-parameter";


// Report
export const GET_OPERATOR_REPORT_DATA = API + ADMIN + "booking/operator-report-data";

// FTC Partner
export const GET_FTC_PARTNERS_LIST = API + ADMIN + "list-ftc-partners"